import React from "react";
import {
  Button,
  Container,
  HeaderWrapper,
  Logo,
  MediaButton,
  MediaButtons,
  Row,
  SearchInput,
  SideMenuButton,
  SiteInfo,
} from "./header.styles";
import SiteMap from "assets/icons/site-map.svg";
import Instagram from "assets/icons/instagram.svg";
import Facebook from "assets/icons/facebook.svg";
import Youtube from "assets/icons/youtube.svg";
import X from "assets/icons/x.svg";
import Search from "assets/icons/search.svg";
import Accessibility from "assets/icons/accessibility.svg";
import Menu from "assets/icons/menu.svg";
import { useAppState } from "main/context/app-context";
import { useNavigate } from "react-router-dom";
import { AccessibilityToolbar } from "./accessibilityToolbar";

interface HeaderProps {
  showNavMenu: () => void;
}

export const Header: React.FC<HeaderProps> = ({ showNavMenu }) => {
  const { applicationData } = useAppState();
  const navigate = useNavigate();

  const handleShowMenu = () => {
    showNavMenu();
  };

  const openUrlDefaultIIsNull = (url: string | undefined, defautlUrl: string) => {
    if (url !== undefined && url !== null) {
      window.open(url, "_blank")
    } else {
      window.open(defautlUrl, "_blank")
    }
  }
  return (
    <header role="banner">
      <SiteInfo>

        <Row>

          <AccessibilityToolbar />

          <Button
            className="social-button"
            onClick={() => {
              navigate("/acessibilidade");
            }}
            aria-label="Página de acessibilidade"
            title="Acessibilidade"
          >
            <img
              src={Accessibility}
              alt=""
              aria-hidden="true"
            />
          </Button>

        </Row>

      </SiteInfo>
      <HeaderWrapper>

        <Container style={{ justifyContent: "flex-start" }} id="search">

          <SearchInput placeholder="Buscar no site"
            aria-label="Campo de busca do portal" />
          <img className="search-icon" alt="Procurar" src={Search} />
        </Container>

        <Container style={{ justifyContent: "center" }}>
          <Logo src={"data:image/png;base64, " + applicationData?.entity?.brandLogo} alt={applicationData?.entity?.name} />
        </Container>
        <MediaButtons>
                <MediaButton onClick={() => openUrlDefaultIIsNull(applicationData?.entity?.socialMedia?.facebookProfile, "https://www.facebook.com/")}
          >
            <img src={Facebook} alt={"Facebook" + applicationData?.entity?.name} />
          </MediaButton>
                  <MediaButton onClick={() => openUrlDefaultIIsNull(applicationData?.entity?.socialMedia?.instagramProfile, "https://www.instagram.com/")}>
            <img src={Instagram} alt={"Instagram" + applicationData?.entity?.name} />
          </MediaButton>
                  <MediaButton onClick={() => openUrlDefaultIIsNull(applicationData?.entity?.socialMedia?.youtubeProfile, "https://www.youtube.com/")}>
            <img src={Youtube} alt={"houtube" + applicationData?.entity?.name} />
          </MediaButton>
          <MediaButton onClick={() => openUrlDefaultIIsNull(applicationData?.entity?.socialMedia?.twitterProfile, "https://x.com/")}>
            <img src={X} alt={"Twitter" + applicationData?.entity?.name} />
          </MediaButton>
        </MediaButtons>
                <SideMenuButton onClick={() => handleShowMenu()}
          aria-label="Abrir menu lateral">
          <img src={Menu} alt="" />
        </SideMenuButton>
      </HeaderWrapper>
    </header>
  );
};

